import styled from '@emotion/styled';
import margins from '../../utils/caluclateMargins';

export const Wrapper = styled.div`
  position: relative;
`;

export const TextsWrapper = styled.div`
  ${margins}
`;

export const ImageWrapper = styled.div`
  position: absolute;
  top: 50%;

  left: ${({ theme }) => theme.vars.sectionPaddingLeftD};
  max-width: 300px;
  width: 25%;
  bottom: 3rem;
  transform: translate(0, -50%);

  ${({ theme }) => theme.media.tablet} {
    display: none;
  }
`;
